import { useRef, useState, useEffect } from "react";
import arrow_horizontal from "../../assets/svg/arrow-horizontal.svg";

const DraggableDivider = ({ leftRef, rightRef }) => {
  const dividerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const startDrag = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const stopDrag = () => setIsDragging(false);

  const onDrag = (e) => {
    if (!isDragging) return;
    const container = leftRef.current.parentElement; 
    const containerRect = container.getBoundingClientRect();
    const pointerX = e.clientX - containerRect.left;

    const minWidth = 100;
    const maxWidth = containerRect.width - minWidth;

    if (pointerX < minWidth || pointerX > maxWidth) return;

    leftRef.current.style.flex = `0 0 ${pointerX}px`;
    rightRef.current.style.flex = `1 1 0px`;
  };

  useEffect(() => {
    window.addEventListener("mousemove", onDrag);
    window.addEventListener("mouseup", stopDrag);
    return () => {
      window.removeEventListener("mousemove", onDrag);
      window.removeEventListener("mouseup", stopDrag);
    };
  }, [isDragging]);

  return (
    <div
      ref={dividerRef}
      className="vertical-divider"
      onMouseDown={startDrag}
    >
      <img
        src={arrow_horizontal}
        alt="drag-icon"
        className="contract-drag-image"
        draggable="false"
      />
    </div>
  );
};

export default DraggableDivider;
